// src/contexts/ThemeContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [corApp, setCorApp] = useState('#FF6F00');
  const [corFonteApp, setCorFonteApp] = useState('#FFF');
  const [configModulo, setConfigModulo] = useState({});
  const [loadingTheme, setLoadingTheme] = useState(true);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const baseURL = window.APP_CONFIG?.Url_Api;
        const response = await axios.get(baseURL + '/ConfigModulo');
        const data = response.data;

        if (data?.length > 0) {
          setCorApp(data[0].corApp || '#FF6F00');
          setCorFonteApp(data[0].corFonteApp || '#FFF');
          setConfigModulo(data[0] || {});
        }
      } catch (error) {
        console.error("Erro ao buscar corApp:", error);
      } finally {
        setLoadingTheme(false);
      }
    };

    fetchConfig();
  }, []);

  useEffect(() => {
    document.documentElement.style.setProperty('--cor-app', corApp);
    document.documentElement.style.setProperty('--cor-fonte-app', corFonteApp);
  }, [corApp, corFonteApp]);

  return (
    <ThemeContext.Provider value={{ corApp, corFonteApp, configModulo, loadingTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};


export const useTheme = () => useContext(ThemeContext);
